/** PDP-only sticky sizing. Variant, media, cart and dialog events stay native. */
class ElorenePdp extends HTMLElement {
  #observer;
  #frame;
  #resize = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#measure());
  };

  connectedCallback() {
    this.#observer = new ResizeObserver(this.#resize);
    this.#observer.observe(this);
    const details = this.querySelector('.product-details');
    if (details) this.#observer.observe(details);
    const header = document.querySelector('#header-group');
    if (header) this.#observer.observe(header);
    window.addEventListener('resize', this.#resize, { passive: true });
    this.#resize();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    window.removeEventListener('resize', this.#resize);
    cancelAnimationFrame(this.#frame);
  }

  #measure() {
    const details = this.querySelector('.product-details');
    if (!details || this.dataset.sticky !== 'true') return;
    // Probe resolves inherited calc() values maintained by Horizon's header.
    const probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(--sticky-header-offset,0px)';
    this.append(probe);
    const headerOffset = probe.getBoundingClientRect().height;
    probe.remove();
    // A tall panel can scroll completely into view before sticking at its bottom.
    const availableTop = window.innerHeight - details.getBoundingClientRect().height - 24;
    const top = Math.min(headerOffset + 16, availableTop);
    details.style.setProperty('--pdp-sticky-top', `${Math.round(top)}px`);
  }
}
if (!customElements.get('elorene-pdp')) customElements.define('elorene-pdp', ElorenePdp);
